import { styled } from '@mui/material';

import { useSimulationWidgetContext } from '../../../../hooks/useSimulationWidgetContext';
import { ActionWebReport } from './components/ActionWebReport';
import { ActionDetails } from './components/ActionDetails';
import { ActionTryAgain } from './components/ActionTryAgain';
import { ActionStop } from './components/ActionStop';
import { ActionStart } from './components/ActionStart';
import { ActionRunExtended } from './components/ActionRunExtended';

const StyledSummary = styled('footer')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

export const SimulationActions = () => {
  const { latestReview, parsedStatus } = useSimulationWidgetContext();

  return (
    <StyledSummary>
      {!latestReview || parsedStatus === null ? <ActionStart /> : null}
      {parsedStatus === 'IN_PROGRESS' ? <ActionStop /> : null}
      {['CANCELED', 'COMPLETED'].includes(parsedStatus || '') ? (
        <ActionRunExtended />
      ) : null}

      {parsedStatus && ['COMPLETED', 'CANCELED'].includes(parsedStatus) ? (
        <ActionWebReport />
      ) : null}

      {['CANCELED', 'COMPLETED'].includes(parsedStatus || '') ? (
        <ActionTryAgain />
      ) : null}

      {latestReview && !!parsedStatus ? <ActionDetails /> : null}
    </StyledSummary>
  );
};
